
window._klipshop = {
    galleryFadeSpeed: 125,
};

export default window._klipshop;
